import { hashMaterialProperties, ShadingMode, OutlineMode } from "flavr-common";
import { TRUNCATED_CONE_INSTANCE_SHADER } from "./TruncatedConeInstanceShader";
import { BackSide } from "three";
import { createGeometryMaterial } from "./instance.shader";
import { CustomShaderMaterial } from "../../shader/CustomShaderMaterial";
export const MATERIALS_FOR_TRUNCATED_CONES = new Map();
export function getTruncatedConeMaterial(properties) {
    const hash = hashMaterialProperties(properties);
    let material = MATERIALS_FOR_TRUNCATED_CONES.get(hash);
    if (!material) {
        const defines = {
            USE_INSTANCE_COLOR: "",
            IS_TRUNCATED_CONE: ""
        };
        material = createGeometryMaterial(defines, TRUNCATED_CONE_INSTANCE_SHADER.uniforms, properties, false);
        MATERIALS_FOR_TRUNCATED_CONES.set(hash, material);
    }
    return material;
}
export function getTruncatedConeReducedMaterial() {
    let material = MATERIALS_FOR_TRUNCATED_CONES.get("Reduced");
    if (!material) {
        const defines = {
            USE_INSTANCE_COLOR: "",
            IS_TRUNCATED_CONE: "",
            MONOCHROME: ""
        };
        material = createGeometryMaterial(defines, TRUNCATED_CONE_INSTANCE_SHADER.uniforms, {
            shading: ShadingMode.Phong,
            outline: OutlineMode.Straight
        }, false);
        MATERIALS_FOR_TRUNCATED_CONES.set("Reduced", material);
    }
    return material;
}
export function getTruncatedConeDepthMaterial() {
    let material = MATERIALS_FOR_TRUNCATED_CONES.get("Depth");
    if (!material) {
        material = new CustomShaderMaterial({
            defines: { IS_TRUNCATED_CONE: "" },
            vertexShader: TRUNCATED_CONE_INSTANCE_SHADER.depthVertexShader,
            fragmentShader: TRUNCATED_CONE_INSTANCE_SHADER.depthFragmentShader,
            uniforms: TRUNCATED_CONE_INSTANCE_SHADER.uniforms,
            side: BackSide
        });
        MATERIALS_FOR_TRUNCATED_CONES.set("Depth", material);
    }
    return material;
}
